export const CLERK_APPEARANCE = {
  colorPrimary: '#34d399',
  colorBackground: '#082f49',
  colorForeground: '#ffffff',
  colorMutedForeground: '#9ca3af',
  colorInput: '#06263a',
  colorInputForeground: '#ffffff',
  colorNeutral: '#ffffff',
  borderRadius: '0.5rem',
  fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif',
} as const;

export const CLERK_TEXTS = {
  signIn: {
    start: {
      title: 'Sign in to Spare Cores Sentinel',
      titleCombined: 'Sign in to Spare Cores Sentinel',
      subtitle: 'Welcome back!',
      subtitleCombined: 'Welcome back!',
      actionText: 'Don’t have an account?',
      actionLink: 'Register!',
    },
  },
  signUp: {
    start: {
      actionText: 'Already have an account?',
      actionLink: 'Log in',
    },
    continue: {
      actionText: 'Already have an account?',
      actionLink: 'Log in',
    },
  },
} as const;
